import React from 'react'

import * as R from 'ramda'

import { Button, H1, P } from '@driftt/tide-core'

import NotificationModal from 'components/NotificationModal'

import './styles.css'

const VerifyEmail = ({
  onResendEmail,
  loading,
  email,
  showError,
  showSuccessNotification,
}) => {
  const displayEmail = R.isEmpty(email) || R.isNil(email) ? 'your email' : email

  return (
    <div className="touchless-email-verification">
      <H1 className="touchless-email-verification-header">Verify your email</H1>
      <P className="touchless-email-verification-text">
        Please verify your email address to complete registration.
      </P>
      <P className="touchless-email-verification-text">
        An email has been sent to {displayEmail} with a link to verify your
        account. If you have not received the email after a few minutes, please
        check your spam folder.
      </P>
      {showError && (
        <P className="email-verification-error">
          There was an error sending your verification email. Please try again!
        </P>
      )}
      <Button
        loading={loading}
        className="touchless-email-verification-button"
        type="tertiary"
        onClick={onResendEmail}
      >
        Resend email
      </Button>
      <NotificationModal
        showModal={showSuccessNotification}
        text="Your verification email has been sent!"
      />
    </div>
  )
}

export default VerifyEmail
